import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { motion } from "framer-motion";

const Opiniones = () => {
  const opiniones = [
    {
      fecha: "Miercoles 21 de Julio , 2021",
      opinion:
      " Me encanto la atención, son super profesionales. ",
      nombre: "Wendy Aguilar Cruz",
      cargo: "Gerente de ventas, Aservic / Puebla",
    },
    {
      fecha: "Martes 31 de Agosto , 2021",
      opinion:
      " No tenía idea de que pasos seguir para registrar mi libro. En GDA me ayudaron al registro. Además el GDA Magazine es una maravilla. ",
      nombre: "Alejandra Cervantes",
      cargo: "Periodista, Nogales, Sonora",
    },
    {
      fecha: "Martes 7 de Diciembre , 2021",
      opinion:
      " Un familiar deseaba cederme los derechos de algunos de sus libros, algunos publicados hace aproximadamente 25 años. Ni él, ni yo sabíamos como realizar el trámite, hasta que me acerqué a GDA. Fue más fácil de lo que pensamos, la atención e información que te brindan es concreta y fácil de entender. ",
      nombre: "Omar Mejía",
      cargo: "Administrador de Empresas, Toluca, Estado de México",
    },
    {
      fecha: "Viernes 14 de Enero , 2022",
      opinion:
      " Me encantan los artículos que hay en el GDA Magazine. Puedo decir con orgullo que llevo 14 artículos en la revista digital, espero que sean muchos más, me siento motivada por el apoyo que GDA nos brinda a los autores. ",
      nombre: "Laura Lobato",
      cargo: "Escritora independiente, Ciudad de México",
    },
    {
      fecha: "Viernes 10 de Septiembre , 2021",
      opinion:
      " Llevo más de 10 años escribiendo y cantando mis propias canciones, lo he hecho en eventos privados o en algunos restaurantes de Puebla. Un amigo me dijo que no registrar mis canciones y exponerlas era muy riesgoso. Me acerqué a GDA y me ayudaron de inmediato. ",
      nombre: "Carlos Alducín",
      cargo: "Cantautor, Atlixco, Puebla",
    },
  ];

  return (
    <div className="relative w-full h-screen flex flex-col items-center justify-center px-4 md:px-24 text-[#028299] bg-teal-200/25 overflow-hidden">
      <motion.h2
        className="text-4xl font-bold mb-6"
        initial={{ y: -40, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        Por qué la gente confía en nosotros
      </motion.h2>

      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000 }}
        loop={true}
        className="w-full md:w-3/4"
      >
        {opiniones.map((op, idx) => (
          <SwiperSlide key={idx}>
            <motion.div
              className="flex flex-col items-center gap-6 text-center px-6"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <p className="font-light">{op.fecha}</p>
              <h2 className="text-xl md:text-2xl font-semibold leading-relaxed">
                “{op.opinion}”
              </h2>

              <div className="px-6 py-4 bg-[#028299] text-white rounded-full text-center">
                <p className="text-lg font-medium">{op.nombre}</p>
                <p className="text-sm">{op.cargo}</p>
              </div>
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Opiniones;
